import {isFeatureEnabled} from '@github-ui/feature-flags'

import {CodingAssistantButton} from './CodingAssistantButton'

type StartWorkButtonProps = {
  url: string
  planBody: string
}

function buildPrompt(issueUrl: string, planBody: string): string {
  return `I've created a plan for ${issueUrl}, please implement this plan:\n\n${planBody.trim()}`
}

export function StartWorkButton({url, planBody}: StartWorkButtonProps) {
  const enabled = isFeatureEnabled('issues_open_in_tool_links')
  if (!enabled) return null

  return (
    <CodingAssistantButton
      url={url}
      buttonLabel="Start work"
      promptBuilder={issueUrl => buildPrompt(issueUrl, planBody)}
      showButtonText
    />
  )
}
